export const currencySymbols = {
  USD: "$",
  EUR: "€",
  GBP: "£",
  MAD: "د.م.",
  CAD: "CA$",
  AUD: "A$",
  JPY: "¥",
};